import { render } from "./ComercialesPage.vue?vue&type=template&id=7b6c0f3a"
import script from "./ComercialesPage.vue?vue&type=script&lang=js"
export * from "./ComercialesPage.vue?vue&type=script&lang=js"

import "./ComercialesPage.vue?vue&type=style&index=0&id=7b6c0f3a&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__